var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"type":_vm.type,"icon":_vm.icon,"disabled":_vm.disabled,"label":_vm.label,"loading":_vm.loading,"design":"contained","save":_vm.save,"remove":_vm.remove},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }